module.exports = __webpack_public_path__ + "img/table_blue.68abaade.svg";